<script setup>
import { useI18n } from 'vue-i18n';
import { formatMoney } from '../composables/commissionSheetForm';

defineProps({
  summary: { type: Object, default: () => ({}) },
});

const { t } = useI18n();
const percentage = value => `${Number(value || 0)}%`;
const money = value => formatMoney(value?.amount_cents || 0);
</script>

<template>
  <section class="grid gap-2 lg:grid-cols-2">
    <article
      class="rounded-lais border border-lais-border-soft bg-white px-4 py-3 shadow-lais-card"
    >
      <dl class="grid grid-cols-[1fr_auto] text-sm">
        <dt class="py-1 text-lais-text-muted">
          {{ t('REAL_ESTATE_COMMISSION_PLAN.FOOTER.DISTRIBUTED_PERCENTAGE') }}
        </dt>
        <dd
          data-testid="distributed-percentage"
          class="py-1 text-lais-text-muted"
        >
          {{ percentage(summary.distributed_percentage) }}
        </dd>
        <dt class="border-b border-lais-border-soft py-1 text-lais-text-muted">
          {{ t('REAL_ESTATE_COMMISSION_PLAN.FOOTER.COMPANY_REMAINING') }}
        </dt>
        <dd class="border-b border-lais-border-soft py-1 text-lais-text-muted">
          {{ percentage(summary.company_percentage) }}
        </dd>
        <dt class="pt-2 font-semibold text-lais-text">
          {{ t('REAL_ESTATE_COMMISSION_PLAN.FOOTER.TOTAL_PERCENTAGE') }}
        </dt>
        <dd class="pt-2 font-bold text-emerald-700">
          {{ percentage(summary.total_percentage) }}
        </dd>
      </dl>
    </article>

    <article
      class="rounded-lais border border-lais-border-soft bg-white px-4 py-3 shadow-lais-card"
    >
      <dl class="grid grid-cols-[1fr_auto] text-sm">
        <dt class="py-1 text-lais-text-muted">
          {{ t('REAL_ESTATE_COMMISSION_PLAN.FOOTER.DISTRIBUTED_AMOUNT') }}
        </dt>
        <dd data-testid="distributed-amount" class="py-1 text-lais-text-muted">
          {{ money(summary.distributed_amount) }}
        </dd>
        <dt class="border-b border-lais-border-soft py-1 text-lais-text-muted">
          {{ t('REAL_ESTATE_COMMISSION_PLAN.FOOTER.COMPANY_REMAINING') }}
        </dt>
        <dd class="border-b border-lais-border-soft py-1 text-lais-text-muted">
          {{ money(summary.company_amount) }}
        </dd>
        <dt class="pt-2 font-semibold text-lais-text">
          {{ t('REAL_ESTATE_COMMISSION_PLAN.FOOTER.NET_AMOUNT') }}
        </dt>
        <dd class="pt-2 font-bold text-emerald-700">
          {{ money(summary.net_amount) }}
        </dd>
      </dl>
    </article>
  </section>
</template>
